<template>
  <div class="recycle-bin-container">
    <a-page-header 
      title="回收站" 
      sub-title="已删除的知识"
      @back="() => $router.back()"
    />

    <a-card style="margin-top: 16px">
      <a-table
        :columns="columns"
        :data-source="dataSource"
        :loading="loading"
        :pagination="pagination"
        row-key="id"
        @change="handleTableChange"
      >
        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'type_name'">
            <a-tag>{{ record.type_name || '-' }}</a-tag>
          </template>
          <template v-else-if="column.key === 'version'">
            <span>v{{ record.latest_version || 1 }}</span>
            <span v-if="record.published_version" style="margin-left: 8px; color: #52c41a;">
              (已发布: v{{ record.published_version }})
            </span>
          </template>
          <template v-else-if="column.key === 'update_time'">
            {{ formatDate(record.update_time) }}
          </template>
          <template v-else-if="column.key === 'action'">
            <a-space>
              <a-button type="link" size="small" @click="handleViewHistory(record)">
                版本历史
              </a-button>
              <a-popconfirm
                title="确定要恢复此知识吗？"
                @confirm="handleRestore(record)"
              >
                <a-button type="link" size="small">恢复</a-button>
              </a-popconfirm>
            </a-space>
          </template>
        </template>
      </a-table>
    </a-card>
  </div>
</template>

<script>
import { ref, reactive, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { message } from 'ant-design-vue';
import { getRecycleBinList, restoreKnowledge } from '../api/knowledge';

export default {
  name: 'KnowledgeRecycleBin',
  setup() {
    const router = useRouter();
    const loading = ref(false);
    const dataSource = ref([]);
    
    const pagination = reactive({
      current: 1,
      pageSize: 20,
      total: 0,
      showSizeChanger: true,
      showQuickJumper: true,
      showTotal: (total) => `共 ${total} 条`
    });

    const columns = [
      { title: 'ID', dataIndex: 'id', key: 'id', width: 80 },
      { title: '标题', dataIndex: 'title', key: 'title', ellipsis: true },
      { title: '知识类型', key: 'type_name', width: 120 },
      { title: '版本', key: 'version', width: 160 },
      { title: '删除时间', key: 'update_time', width: 180 },
      { title: '操作', key: 'action', width: 180, fixed: 'right' }
    ];

    const formatDate = (dateString) => {
      if (!dateString) return '-';
      const date = new Date(dateString);
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
    };

    const loadData = async () => {
      loading.value = true;
      try {
        const res = await getRecycleBinList({
          page: pagination.current,
          pageSize: pagination.pageSize
        });
        
        const responseData = res.data || {};
        dataSource.value = responseData.items || [];
        pagination.total = responseData.total || 0;
      } catch (error) {
        message.error('加载数据失败');
        console.error(error);
      } finally {
        loading.value = false;
      }
    };

    const handleTableChange = (pag) => {
      pagination.current = pag.current;
      pagination.pageSize = pag.pageSize;
      loadData();
    };

    const handleViewHistory = (record) => {
      router.push({ 
        name: 'knowledge-version-history', 
        params: { id: record.id },
        query: { title: record.title, deleted: '1' }
      });
    };

    const handleRestore = async (record) => {
      try {
        await restoreKnowledge(record.id);
        message.success('恢复成功');
        await loadData();
      } catch (error) {
        message.error('恢复失败');
      }
    };

    onMounted(() => {
      loadData();
    });

    return {
      loading,
      dataSource,
      pagination,
      columns,
      formatDate,
      handleTableChange,
      handleViewHistory,
      handleRestore
    };
  }
};
</script>

<style scoped>
.recycle-bin-container {
  padding: 16px;
}
</style>

